/* eslint-disable */
jQuery('.area-menu__navigation ul > .menu-item-has-children > a').on('click', function (event) {
  event.preventDefault();

  jQuery(this).parent().toggleClass('menu-item-has-children--open');
  jQuery('.area-menu').animate({ scrollTop: 0 }, 600);
});

jQuery('.area-menu__navigation ul > .menu-item-has-children > .sub-menu').on('click', (event) => {
  jQuery('.area-menu__navigation ul > .menu-item-has-children').removeClass('menu-item-has-children--open');
});
